/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxcFundingV1SourceQueryServiceSourceGetResponse, IxcFundingV1SourceQueryServiceSourceGetSourceGetRequest } from '@interxfi/types';

export const IXC_FUNDING_V1_SOURCE_QUERY_SERVICE_SOURCE_GET_AUDIENCE = ['clearing', 'program'];

export async function ixcFundingV1SourceQueryServiceSourceGet(baseUrl: string | undefined, request?: IxcFundingV1SourceQueryServiceSourceGetSourceGetRequest, requestInit?: RequestInit): Promise<IxcFundingV1SourceQueryServiceSourceGetResponse | undefined> { return makeRequest<IxcFundingV1SourceQueryServiceSourceGetResponse, IxcFundingV1SourceQueryServiceSourceGetSourceGetRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/ixc/funding/v1/source/q/:sourceId', request, requestInit)); }

